import * as Rx from 'rxjs';

import { printTicketsData } from './types';

export class PrintTicketsService {
  private printTicketsData$: Rx.BehaviorSubject<printTicketsData>;

  constructor() {
    this.printTicketsData$ = new Rx.BehaviorSubject(null);
  }

  public setPrintTicketsData(ticketPrintData: printTicketsData): Rx.Observable<printTicketsData> {
    localStorage.setItem('blinket: ticketPrintData', JSON.stringify(ticketPrintData));
    this.printTicketsData$.next(ticketPrintData);
    return Rx.of(ticketPrintData);
  }

  public getPrintTicketsData(): Rx.Observable<printTicketsData> {
    const ticketPrintData = JSON.parse(localStorage.getItem('blinket: ticketPrintData'));
    return new Rx.BehaviorSubject(ticketPrintData).asObservable();
  }
}

const printTicketsService = new PrintTicketsService();
export default printTicketsService;
